import React from 'react'
import Facebook from '../../../../assets/img/social/fb.png'
import Instagram from '../../../../assets/img/social/in.png'
import Tiktok from '../../../../assets/img/social/tiktok.svg'
import {
  LeftContent,
  LinksContainer,
  MainContainer,
  SocialsContainer,
  SocialImage,
  SocialButton,
  StyledLink,
  StyledLinkItem,
  StyledTncModalLink,
  StyledPrivacyModalLink,
  Copyright,
  PoweredBy,
} from './Footer.style'

const Footer = () => {
  return (
    <MainContainer>
      <LeftContent>
        <SocialsContainer>
          {/* SOCIAL MEDIA BUTTONS */}
          <SocialButton
            href="https://www.facebook.com/zingbyayalamalls"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SocialImage image={Facebook} />
          </SocialButton>
          <SocialButton
            href="https://instagram.com/zingayalamalls"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SocialImage image={Instagram} />
          </SocialButton>
          <SocialButton
            href="https://www.tiktok.com/@iloveayalamalls"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SocialImage image={Tiktok} />
          </SocialButton>
        </SocialsContainer>
        <LinksContainer>
          <StyledLinkItem>
            <StyledLink
              to="/main/malls"
              target="_blank"
              rel="noopener noreferrer"
            >
              Our Malls
            </StyledLink>
          </StyledLinkItem>
          <StyledLinkItem>
            <StyledLink
              to="/promos-and-events/whats-on"
              target="_blank"
              rel="noopener noreferrer"
            >
              Events
            </StyledLink>
          </StyledLinkItem>
          <StyledLinkItem>
            <StyledPrivacyModalLink>Privacy Notice</StyledPrivacyModalLink>
          </StyledLinkItem>
          <StyledLinkItem>
            <StyledTncModalLink tab="tnc">
              Terms and Conditions
            </StyledTncModalLink>
          </StyledLinkItem>
        </LinksContainer>
        <Copyright>
          Copyright © 2019 AyalaLand Malls, Inc. All Rights Reserved
        </Copyright>
      </LeftContent>
      <PoweredBy
        href="https://www.whitecloak.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Powered by White Cloak Technologies Inc.
      </PoweredBy>
    </MainContainer>
  )
}

export default Footer
